class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    console.log('CartItems initialized');
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
    //Fast Simon update Upsell
    const widgetScript = document.createElement('script');
    widgetScript.src =
      'https://static-recommendations.fastsimon.com/no-code-recommendations/fs-recommendations-init.js?uuid=' +
      window.FS_UUID +
      '&store_id=' +
      window.FS_STORE_ID +
      '&platform=Shopify&widgetId=' +
      window.FS_WIDGET_ID +
      '&v=' +
      Date.now();
    document.head.appendChild(widgetScript);
    document.dispatchEvent(new CustomEvent('swym:button-loaded'));
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerSectionId =
        cartDrawer && typeof cartDrawer.getCartDrawerSectionId === 'function'
          ? cartDrawer.getCartDrawerSectionId()
          : 'cart-drawer';

      fetch(`${routes.cart_url}?section_id=${cartDrawerSectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    const element = document.querySelector('#eg-cart-upsell script');
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (window.enabled_max_units && parsedState.item_count > 0) {
          window.order_count = parsedState.item_count;
        }
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors) {
          if (quantityElement.max && parseInt(quantity) > parseInt(quantityElement.max)) {
            quantityElement.value = quantityElement.max;
          } else {
            const match = parsedState.errors.match(/(\d+)/);
            if (match) {
              quantityElement.value = parseInt(match[1]);
            } else {
              quantityElement.value = quantityElement.getAttribute('value');
            }
          }
          this.updateLiveRegions(line, parsedState.errors);
          this.updateQuantity(line, quantityElement.value, name, variantId);
          return;
        }

        requestIdleCallback(() => {
          const isCarvelaBrand =
            document.body.classList.contains('brand-carvela') ||
            document.documentElement.dataset.isCarvelaBrand === 'true' ||
            document.documentElement.dataset.brand === 'carvela';

          const syncCarvelaCartIconCount = (itemCount) => {
            const count = Number(itemCount || 0);

            const alpineCount = document.getElementById('cart-icon-count');
            if (alpineCount) {
              alpineCount.textContent = String(count);
              alpineCount.classList.toggle('hidden', count === 0);
            }

            const legacyBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
            if (legacyBubble) {
              const numberNode = legacyBubble.querySelector('[aria-hidden="true"]') || legacyBubble.querySelector('span');
              if (numberNode) numberNode.textContent = String(count);

              const srNode = legacyBubble.querySelector('.visually-hidden');
              if (srNode) srNode.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
            }
          };

          this.classList.toggle('is-empty', parsedState.item_count === 0);

          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            if (isCarvelaBrand && section.id === 'cart-icon-bubble') {
              return;
            }

            if (document.getElementById(section.id) != null) {
              console.log('Updating section:', section.id);
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });

          if (isCarvelaBrand) {
            syncCarvelaCartIconCount(parsedState.item_count);
          }

          const upsellWrapperId = 'eg-cart-upsell';
          let upsellWrapper = document.getElementById(upsellWrapperId);
          if (!upsellWrapper) {
            upsellWrapper = document.createElement('div');
            upsellWrapper.id = upsellWrapperId;
            document.querySelector('cart-drawer')?.appendChild(upsellWrapper);
          } else {
            upsellWrapper.innerHTML = '';
          }

          const updatedValue = parsedState.items[line - 1]?.quantity;
          const oldValue = parseInt(quantityElement.value);
          if (typeof updatedValue !== 'undefined') {
            quantityElement.value = updatedValue;
          }
          let message = '';

          if (updatedValue !== oldValue) {
            message =
              typeof updatedValue === 'undefined'
                ? window.cartStrings.error
                : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }

          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          const inputEl = lineItem?.querySelector(`[name="${name}"]`);

          if (inputEl && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, inputEl);
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
        });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        document.dispatchEvent(new CustomEvent('cart-update'));

        setTimeout(() => {
          const existingFastSimon = document.querySelector('script[src*="fastsimon"]');
          if (existingFastSimon) {
            existingFastSimon.remove();
          }

          const widgetScript = document.createElement('script');
          widgetScript.src = `https://static-recommendations.fastsimon.com/no-code-recommendations/fs-recommendations-init.js?uuid=${
            window.FS_UUID
          }&store_id=${window.FS_STORE_ID}&platform=Shopify&widgetId=${window.FS_WIDGET_ID}&v=${Date.now()}`;
          document.head.appendChild(widgetScript);

          if (!document.querySelector('script[src*="shoppinggives"]')) {
            const SGscript = document.createElement('script');
            SGscript.src = window.location.hostname.includes('betseyjohnson')
              ? 'https://cdn.shoppinggives.com/cc-utilities/shopify-add-on.js?sid=42916bca-4379-4147-bf59-6bfb7d9c9737&target-element=shopping-gives'
              : 'https://cdn.shoppinggives.com/cc-utilities/shopify-add-on.js?sid=3b54deaa-771d-4636-a376-15e3ca4dbdd9&target-element=shopping-gives';
            document.head.appendChild(SGscript);
          }

          document.dispatchEvent(new CustomEvent('swym:button-loaded'));
        }, 0);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (new DOMParser().parseFromString(html, 'text/html').querySelector(selector) !== null) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
